<template>
  <div
    :id="employer.id"
    class="member-card"
    :class="{ editable: employer.id != 0 }"
  >
    <editBox
      :option="['edit', 'remove']"
      :item="'employer'"
      :itemId="employer.id"
      displayMode="vertical_right"
      v-if="employer.id != 0"
    />
    <div class="member-top-row">
      <div class="img-div">
        <img
          :src="
            employer.id == 0
              ? getImgUrl(employer.employee_img)
              : 'https://witrino.com/' + employer.employee_img
          "
          alt=""
        />
      </div>
      <!-- <router-link
      v-if="member.chatActive"
      class="chat-btn"
      :to="'/' + token + '/chat/' + employer.id"
    ></router-link> -->
      <div class="member-detail">
        <p class="member-name">
          {{ employer.user_name }}
        </p>

        <p class="member-grade">
          {{ employer.grade }}
        </p>

        <!-- <span class="member-expertise">
        <p>تخصص:</p>
        <p>{{ employer.grade }}</p>
      </span> -->

        <!-- <div class="bottom-div">
        
      </div> -->
      </div>
      <div class="call_btn_box">
        <div class="call_btn" @click="showCallData = !showCallData"></div>
      </div>
    </div>
    <div class="member-bottom-row" :class="{ show_callbox: showCallData }">
      <div class="social_media">
        <a href="" class=""
          ><img
            src="@/assets/img/public/social-networks/colored_icon/instagram.svg"
            alt=""
        /></a>
        <a href="" class=""
          ><img
            src="@/assets/img/public/social-networks/colored_icon/telegram.svg"
            alt=""
        /></a>
        <a href="" class=""
          ><img
            src="@/assets/img/public/social-networks/colored_icon/whatsapp.svg"
            alt=""
        /></a>
      </div>
      <p class="phone">
        <a
          :href="
            phoneChecker(employer.mobile)
              ? 'tel:' + employer.mobile
              : '#member-list-section'
          "
          style="color: inherit; font: inherit"
          >{{ phoneChecker(employer.mobile) || ". . ." }}</a
        >
      </p>
    </div>
  </div>
</template>

<script>
import { sellerData } from "@/repo/sellerData.js";
import { publicHelpers } from "@/public/helpers.js";
import editBox from "@/components/editBox/index.vue";
export default {
  name: "MemberCard",
  components: {
    editBox,
  },
  mixins: [sellerData, publicHelpers],
  props: ["employer", "token"],
  data() {
    return { showCallData: false };
  },
  methods: {},
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/MemberCard/MemberCard.css);
</style>